const SKILLS_COLORS = {
    integrate: '#65C2FD',
    locate: '#828DF6',
    reflect: '#6DCDDD',
    readingComprehension: '#514585',
}

export { SKILLS_COLORS }
